import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import { authEvents, AUTH_EVENTS } from 'services/api/authEvents';
import { sessionExpired } from 'features/auth/authSlice';
import { notify } from 'features/ui/uiSlice';
import { MESSAGES } from 'constants/messages';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // parseApiError attaches the raw axios error in rejected payloads.
        ignoredActionPaths: ['payload.raw', 'meta.arg'],
      },
    }),
});

/**
 * Bridge the axios auth-event bus into Redux. This is wired once at startup so
 * the transport layer can stay decoupled from the store.
 */
authEvents.on(AUTH_EVENTS.SESSION_EXPIRED, () => {
  store.dispatch(sessionExpired());
  store.dispatch(notify({ type: 'error', message: MESSAGES.GENERIC.SESSION_EXPIRED }));
});

authEvents.on(AUTH_EVENTS.FORBIDDEN, () => {
  store.dispatch(notify({ type: 'error', message: MESSAGES.GENERIC.FORBIDDEN }));
});

authEvents.on(AUTH_EVENTS.SERVER_ERROR, () => {
  store.dispatch(notify({ type: 'error', message: 'Internal server error. Please try again later.' }));
});

export default store;
